import { CheckCircle2, GitPullRequest, Radar, ShieldCheck } from "lucide-react";
import { formatDate } from "../lib/content";
import type { UpdatesData } from "../types/content";

const flow = [
  [Radar, "每周发现", "只读取允许清单中的官方 Feed 与 Release。"],
  [ShieldCheck, "重要性筛选", "相关性、机制增量、证据和影响面达到 72 分。"],
  [CheckCircle2, "Brad 确认", "候选 Issue 中逐项勾选并添加批准标签。"],
  [GitPullRequest, "验证后更新", "哈希、链接、构建和版权门全部通过才进入站点。"],
] as const;

export function WeeklyUpdates({ updates }: { updates: UpdatesData }) {
  return (
    <section className="updates-section" id="weekly-updates" aria-labelledby="updates-title">
      <div className="section-heading">
        <h2 id="updates-title">每周官方更新</h2>
        <p>
          自动发现可以主动，正式内容必须经过确认。未确认、来源失效或候选哈希变化，
          本周保持零更新。
        </p>
      </div>

      <ol className="update-flow">
        {flow.map(([Icon, title, body], index) => (
          <li key={title}>
            <span className="flow-index">{String(index + 1).padStart(2, "0")}</span>
            <Icon aria-hidden="true" />
            <h3>{title}</h3>
            <p>{body}</p>
          </li>
        ))}
      </ol>

      <div className="approved-updates">
        <div>
          <h3>已确认更新</h3>
          <p>{updates.entries.length} 条资料已通过确认门。</p>
        </div>
        {updates.entries.length ? (
          <div className="update-list">
            {updates.entries.map((entry) => (
              <article key={entry.id}>
                <div>
                  <span>{entry.source}</span>
                  <time dateTime={entry.publishedAt}>{formatDate(entry.publishedAt)}</time>
                </div>
                <h4>
                  <a href={entry.url} target="_blank" rel="noreferrer">
                    {entry.title}
                  </a>
                </h4>
                <p>{entry.summary}</p>
                <ul>
                  {entry.tags.map((tag) => (
                    <li key={tag}>{tag}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        ) : (
          <div className="no-approved-updates">
            首次发布以三篇核心来源的综合稿为基线，等待下一次周度候选。
          </div>
        )}
      </div>
    </section>
  );
}
